import { render, staticRenderFns } from "./DeadsDetail.vue?vue&type=template&id=91d3cf9a&scoped=true"
import script from "./DeadsDetail.vue?vue&type=script&lang=js"
export * from "./DeadsDetail.vue?vue&type=script&lang=js"
import style0 from "./DeadsDetail.vue?vue&type=style&index=0&id=91d3cf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d3cf9a",
  null
  
)

export default component.exports